
import { Component, Vue } from 'vue-property-decorator'
import { State } from "vuex-class"
import User from "@/types/account/user"
import ChangeMail from "@/views/Settings/ChangeMail.vue"
import DeleteAccount from "@/views/Settings/DeleteAccount.vue"

@Component({
  components: {
    DeleteAccount,
    ChangeMail
  }
})
export default class Account extends Vue {
  @State((state: any) => state.user, { namespace: 'account' })
  private user!: User;
}
